// VehTypeGroupCodeDict.js
// DbdbTap 2024-08-22 10:30:12
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    vehTypeGpCd : {
            id: 'vehTypeGpCd',label: '그룹코드',
			type: InputType.text, required: true, toAdd: false, toEdit: true,
			help: '2자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 2)},
		},
    groupName : {
            id: 'groupName',label: '차종그룹', 
			type: InputType.text, required: true, toAdd: true, toEdit: true,
			help: '40자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 40)},
		},
    memo : {
            id: 'memo',label: '메모', 
			type: InputType.text, required: false, toAdd: true, toEdit: true,
			help: '200자 이내로 입력하세요.',
			check: (value) => {return IsValid.string(value, 0, 200)},
		},
    
};

/**
 * VEH_TYPE_GROUP_CODE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-08-22 10:30:12 using DbdbTap
 */
export const VehTypeGroupCodeDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '차종그룹 생성 오류',
        Edit: '차종그룹 수정 오류',
        Remove: '차종그룹 삭제 오류',
        Get: '차종그룹 조회 오류',
    },
    tableProps: {
        tableId: 'vehTypeGroupCodeTable',
        uniqueKey: 'vehTypeGpCd',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'vehTypeGpCd', label: Dict.vehTypeGpCd.label, width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'groupName', label: Dict.groupName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'memo', label: Dict.memo.label, width: 200, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'inherit', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'userName', label: "등록자", width: 80, show: true, option:{align: 'inherit', print:(r,i,v)=>v || r.regUser} },
        ]
    },
};
